module.exports = __webpack_public_path__ + "static/media/alert_simple.38990e6c.wav";